import React from 'react';
import { getClient } from '../apollo/initApollo';

/**
 * Refetches all visible queries on a page so you don't need to prop drill refetches
 *
 * @usage   refetchAll()
 * @returns refetchAll as a prop
 */
export const withRefetch = () => Component => function(props) {
  const client = getClient();
  const refetchAll = client.reFetchObservableQueries;
  return <Component refetchAll={refetchAll} {...props} />;
};
